import _ from 'lodash'
import Vue from 'vue'
import VueRouter from 'vue-router'
import Meta from 'vue-meta'
import App from './App.vue'
import store from '@/vuex/store'
import VueSocketIO from 'vue-socket.io'
import Settings from '@/config/Settings'
import { mappingRoutes } from '@/Route.js'
import Translation from '@/core/mixins/Translation'
import LangMixin from '@/core/mixins/Lang'
import VueClipboard from 'vue-clipboard2'
import '@/core/js/Copyright'

import 'aframe'
import 'aframe-chromakey-material'

import { library } from '@fortawesome/fontawesome-svg-core'
import { faCheck } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

library.add(faCheck)

import { TweenMax, CSSPlugin, TimelineMax, Expo, Back, ScrollToPlugin, DirectionalRotationPlugin, BezierPlugin } from 'gsap/all'
const gsapPlugins = [ TweenMax, CSSPlugin, TimelineMax, Expo, Back, ScrollToPlugin, DirectionalRotationPlugin, BezierPlugin ]

import '@/commons/js/gsap/ThrowPropsPlugin'
import '@/commons/js/gsap/CustomEase'
// import 'gsap-babylon-plugin'

import isMobile from 'ismobilejs'

Vue.use(VueRouter)
Vue.use(Meta,{ keyName: 'head' })
Vue.mixin(Translation)
Vue.use(VueClipboard)
Vue.component('font-awesome-icon', FontAwesomeIcon)
Vue.config.productionTip = false

const routes = [
    { id: 'projection', name: 'home', component: 'Projection', fr: '/accueil/:video?', en: '/home/:video?' }, 
    { id: 'media', name: 'media', component: 'Media', fr: '/media/:room?/:video?', en: '/media_en/:room?/:video?' },
]

const router = new VueRouter({
    mode: 'history',
    routes: mappingRoutes(routes)
})


// const path = (process.env.NODE_ENV !== 'production') ? 'http://localhost:5000' : 'https://meneath-v2.dpt.media'
// const path = 'https://meneathar-stage.nfb.ca'
const path = window.location.origin;

Vue.config.productionTip = false
Vue.use(new VueSocketIO({
    debug: true,
    // connection: 'http://localhost:5000',
    // reconnection: true,
    // reconnectionDelay: 500,
    // maxReconnectionAttempts: Infinity,
    connection: path,
    vuex: {
        store,
        mutationPrefix: "SOCKET_"
    }
}))

new Vue({
    router,
    store,
    mixins: [ LangMixin ],
    head() {
        return {
            htmlAttrs: { lang: this.lang }
        }
    },
    data: () => ({
        width: window.innerWidth,
        height: window.innerHeight,
        isDev: process.env.NODE_ENV !== 'production',
        isProd: process.env.NODE_ENV === 'production',
    }),
    beforeCreate() {
        this.$store.commit('app/LANG_CHANGED', this.$route.meta.lang)
        this.$store.commit('app/SET_FROM_ROUTE', this.$route)
        this.$store.commit('app/SET_TO_ROUTE', this.$route)
    },
    created() {
        window.addEventListener('resize', this.onResize)
        this.$sizes =  {
            phone: 767,
            tabletPortrait: 768,
            tablet: 1024,
        }
    },
    mounted() {
        this.onResize()
    },
    methods: {
        onResize() {
            this.width = window.innerWidth
            this.height = window.innerHeight
        },
        below(type) { return this.width <= this.$sizes[type] },
        above(type) { return this.width >= this.$sizes[type] }
    },
    render: h => h(App)
}).$mount('#app')




















